export default __webpack_public_path__ + "static/media/Cookies.b9433414.md";